import {
    TenantAvatarDocument,
    TenantAvatarQuery,
    TenantAvatarQueryVariables,
} from '@graphql/generated/graphql';

import { AuthService } from '@services/AuthService/AuthService';

import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';

interface UseTenantAvatarProps
    extends QueryHookOptions<TenantAvatarQuery, TenantAvatarQueryVariables> {}

export const useTenantAvatar = ({
    fetchPolicy,
    skip,
    ...rest
}: UseTenantAvatarProps) => {
    const tenantUuid = AuthService.getTenantUuid();

    return useQuery(TenantAvatarDocument, {
        fetchPolicy: fetchPolicy ?? 'network-only',
        notifyOnNetworkStatusChange: true,
        //NOTE: interval 45 min
        pollInterval: 2700000,
        skip: skip || !tenantUuid,
        variables: {
            uuid: tenantUuid || '',
        },
        ...rest,
    });
};
